<template>
  <NuxtLoadingIndicator
    :color="'#f07f56'"
    :height="10"
    :duration="3000"
    :throttle="20"
  />
  <NuxtLayout />
</template>

<script setup>
const { $config } = useNuxtApp()
if ($config.public.DISABLE_PWA !== 'true') {
  useHead({
    link: [{
      rel: 'manifest',
      href: '/manifest.webmanifest'
    }]
  }) 
}
</script>